import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../App.css";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "Spread Across 1.2 Acres in the Heart of Pali Hill",
    "Sea Facing Bedroom Residences with Sundecks",
    "Views of the City and the Sea",
  ];
  const highlights2 = [
    "24 Thoughtfully Curated Amenities across 2 Levels",
    "15,000 Sq. Ft. Rooftop designed for Relaxation & Leisure",
    "50 Metre Long Sky Pool with Breathtaking Views",
  ];

  return (
    <section className="section shadow-sm lazyloaded text-center" id="overview">
      <h1 className="d-block section-heading color-primary text-capitalize text-center">
        {project} - Overview
      </h1>

      <p className="overview-para">
        Nestled in one of Mumbai’s most cherished locales, Rustomjee Crescent at
        Pali Hill, Bandra West, is a rare boutique development offering
        exclusive 3 & 4 BHK spacious residences. Set on a quiet corner of the
        charming Pali Hill, this G + 22 tower combines elegant architecture by
        SOG Design with unobstructed views of the Arabian Sea and city skyline.
        <br />
        Each residence is a celebration of privacy, space, and
        craftsmanship—featuring expansive living areas, seamless
        floor-to-ceiling windows, and modern finishes that speak of understated
        luxury. With only a select number of residences available, Rustomjee
        Crescent offers a coveted lifestyle for those who value intimacy,
        distinction, and timeless elegance in Mumbai’s most prestigious
        neighborhood.
      </p>

      <center>
        <h3 className="mt-3" style={{ fontSize: "1.2rem" }}>
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        className="chat-btn btn btn-info micro-form-btn effetGradient enqModal download_brochure"
        data-form="md"
        data-title="Download Brochure"
        data-btn="Download Now"
        data-enquiry="Download Brochure Welcome Text"
        data-redirect="brochure"
        data-redirect-file="brochure.pdf"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("Overview - Download Brochure")}
      >
        <span className="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
